import { render, staticRenderFns } from "./UserPickerConfig.vue?vue&type=template&id=3bf30d95&scoped=true"
import script from "./UserPickerConfig.vue?vue&type=script&lang=js"
export * from "./UserPickerConfig.vue?vue&type=script&lang=js"
import style0 from "./UserPickerConfig.vue?vue&type=style&index=0&id=3bf30d95&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf30d95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf30d95')) {
      api.createRecord('3bf30d95', component.options)
    } else {
      api.reload('3bf30d95', component.options)
    }
    module.hot.accept("./UserPickerConfig.vue?vue&type=template&id=3bf30d95&scoped=true", function () {
      api.rerender('3bf30d95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/UserPickerConfig.vue"
export default component.exports